import React from 'react';
import { Container, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FaExclamationTriangle } from 'react-icons/fa';

const NotFound = () => {
    return (
        <Container className="d-flex flex-column justify-content-center align-items-center text-center" style={{ minHeight: '60vh' }}>
            <FaExclamationTriangle size={80} className="text-warning mb-4" />
            <h1 className="display-4 fw-bold mb-3">404 - Sayfa Bulunamadı</h1>
            <p className="lead text-muted mb-4">
                Aradığınız sayfa mevcut değil veya taşınmış olabilir.
            </p>
            <Button as={Link} to="/" variant="primary" size="lg">
                Anasayfaya Dön
            </Button>
        </Container>
    );
};

export default NotFound;
